import { Box, TextField, styled } from "@mui/material";

export const ChatInputWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  borderRadius: theme.shape.borderRadius,
  backgroundClip: "padding-box",
  boxShadow: "4px 4px 28px -5px rgba(32, 138, 53, 0.2)",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: theme.shape.borderRadius,
    padding: "3px", // Adjust the width of the border here
    background: "linear-gradient(45deg,rgb(102, 201, 234),rgb(26, 202, 108))",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
  },
  "& .MuiInputBase-input": {
    "&::placeholder": {
      color: "text.secondary",
      fontSize: "16px",
      opacity: 0.7,
    },
  },

  "& .MuiOutlinedInput-root": {
    position: "relative",
    paddingTop: "14px",
    paddingBottom: "14px",
    borderRadius: "5px",
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: "transparent",
    },
    "&.Mui-focused fieldset": {
      borderColor: "transparent",
    },
  },
  "& .MuiOutlinedInput-input": {
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-corner": {
      backgroundColor: "#e0e0e0",
    },
  },
}));

export const AssistantInputField = styled(TextField)(({}) => ({
  position: "relative",
  border: "1.5px solid #D9D9D0",
  bgcolor: "#FAFAF9",
  borderRadius: "5px",
  boxShadow: "0px 0px 2px 0px rgba(0,0,0,0.2)",
  backgroundClip: "padding-box, border-box",
  "& .MuiInputBase-input": {
    "&::placeholder": {
      color: "text.secondary",
      fontSize: "16px",
      opacity: 0.7,
    },
  },
  "& .MuiOutlinedInput-root": {
    position: "relative",
    paddingTop: "15px",
    paddingBottom: "72px",
    borderRadius: "5px",
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: "transparent",
    },
    "&.Mui-focused fieldset": {
      borderColor: "transparent",
    },
  },
  "& .MuiOutlinedInput-input": {
    "&::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-corner": {
      backgroundColor: "#e0e0e0", // Background of the corner between vertical and horizontal scrollbar
    },
  },
}));

export default AssistantInputField;
